module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedication",
    attrs: {
      "id": "ded01"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagev"
    }
  }, [_c('p', {
    staticClass: "dedicationTextNoIndent"
  }, [_vm._v("for Tamyra Heim")]), _vm._v(" "), _c('p', {
    staticClass: "dedicationTextNoIndent"
  }, [_vm._v("and for Jamie Reisch")]), _vm._v(" "), _c('p', {
    staticClass: "dedicationTextNoIndent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("before, during, after")])])]), _c('a', {
    attrs: {
      "id": "pagevi"
    }
  })]), _c('a', {
    attrs: {
      "id": "pagevi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-362a3dcc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780061737190_dedication.vue
// module id = 63
// module chunks = 0